
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/extension-uninstall",
      function () {
        return require("private-next-pages/extension-uninstall.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/extension-uninstall"])
      });
    }
  